/**
 * Dedups the inline previews in the given set of attachment previews
 * @param originalPreviews Attachment previews received from server
 * @return deduped list of the previews
 */
export default function getDedupedInlinePreviews(originalPreviews) {
    var dedupedPreviews = [];
    for (var i = 0, len = originalPreviews.length; i < len; i++) {
        var previewToAdd = originalPreviews[i];
        var previewAttachment = previewToAdd.Attachment;
        var findIndex = -1;
        // Try deduping only inline previews
        if (!!previewAttachment.IsInline) {
            // Find an inline preview with same name and belonging to different item in the dedupedPreviews array
            for (var i_1 = 0; i_1 < dedupedPreviews.length; i_1++) {
                var preview = dedupedPreviews[i_1];
                if (!!preview.Attachment.IsInline &&
                    preview.Attachment.Name == previewAttachment.Name &&
                    preview.ParentItemId.Id != previewToAdd.ParentItemId.Id) {
                    findIndex = i_1;
                    break;
                }
            }
        }
        // Add preview to the deduped previews list if a matching preview was not found
        if (findIndex == -1) {
            dedupedPreviews.push(previewToAdd);
        }
    }
    return dedupedPreviews;
}
//# sourceMappingURL=getDedupedInlinePreviews.js.map